   <template>
  <div>
    <el-dialog title="新增"
               :visible.sync="dialogVisible"
               width="60%">
      <div>
        <div style="">
          <quill-editor ref="myQuillEditor"
                        v-model="content"
                        :options="editorOption"
                        
                        class="my-quill-editor"></quill-editor>
        </div>
        <div style="display:flex;justify-content: flex-end;padding:15px 0;">
          <span slot="footer"
                class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="dialogVisible = false">保 存</el-button>
          </span>
        </div>

      </div>
    </el-dialog>
  </div>
</template>
      
<script>
import { format } from "@/utils/datetime"
export default {
  components: {

  },
  data () {
    return {
      dialogVisible: false,
      form: {},
      content: '',
      editorOption: {
        // 占位配置
        placeholder: '请输入...',
        height: '400px',
        modules: {
          // 配置工具栏
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 上标/下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文本方向
              ['link', 'image', 'video'], // 链接、图片、视频
              [{ align: [] }], // 添加居中按钮
              [{ color: [] }], // 文字颜色按钮
            ]
          },
          // 更改插入的图片大小
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
        }
      },

    }
  },
  created () {

  },
  methods: {
    openDialog () {
      this.dialogVisible = true
    },
  },
  mounted () {

  },

}
</script>
    <style>
      .ql-container {
    height: 400px;
  }

    </style>


// WEBPACK FOOTER //
// src/components/UploadExam/index.vue